<template>
    <b-tabs>
        <b-tab title="Información" active>
            <div class="vehicle-card">
                <table class="table table-bordered table-sm">
                    <thead class="thead-orange">
                        <tr>
                            <th colspan="2">Información del vehículo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><strong>Placa:</strong></td>
                            <td>{{ vehicle.plate }}</td>
                        </tr>
                        <tr>
                            <td><strong>Marca:</strong></td>
                            <td>{{ vehicle.brand }}</td>
                        </tr>
                        <tr>
                            <td><strong>Tipo:</strong></td>
                            <td>
                                {{
                                    !!vehicle.vehicle_type
                                        ? vehicle.vehicle_type.name
                                        : ''
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Interno / Visitante:</strong></td>
                            <td>
                                {{
                                    !!vehicle.internal ? 'Interno' : 'Visitante'
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div
                    class="alert alert-info"
                    v-if="!vehicle.vehicle_photos.length"
                >
                    Este vehículo no tiene fotos
                </div>
                <div v-if="vehicle.vehicle_photos.length">
                    <app-sub-title text="Fotos" />
                    <b-carousel
                        id="vehicle-photos"
                        controls
                        indicators
                        :interval="4000"
                        v-model="slide"
                    >
                        <b-carousel-slide
                            v-for="photo in vehicle.vehicle_photos"
                            :key="photo.id"
                            :img-src="photo.photo_url"
                        />
                    </b-carousel>
                </div>
            </div>
        </b-tab>
        <b-tab title="Historial de ingresos">
            <app-entry-history-vehicle
                :plate="vehicle.plate"
                :client-id="clientId"
            />
        </b-tab>
    </b-tabs>
</template>
<script>
import EntryHistoryVehicle from './EntryHistoryVehicle/EntryHistoryVehicle.vue'
export default {
    components: {
        appEntryHistoryVehicle: EntryHistoryVehicle,
    },

    props: {
        vehicle: {
            type: Object,
            required: true,
        },
        clientId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            photos: [],
            length: '',
            slide: 1,
        }
    },
    methods: {
        cleanFields() {
            this.photos = []
            this.length = ''
        },
    },
    created() {
        this.$bus.$on('view-photos-vehicle.clean', this.cleanFields)
    },
}
</script>
